<script setup>
// Аватарка автора коментаря. Фото є не в кожного — тоді малюємо ініціали на
// кольоровому кружечку. Колір прибитий до імені, а не до позиції в списку: так
// той самий автор скрізь однакового кольору — і в чаті, і під плеєром, і в
// історії коментарів.

const props = defineProps({
  author: { type: String, default: '' },
  avatar: { type: String, default: '' },
  // Ініціали рахує сам comments.app («Mykhailo Zvieriev» -> «MZ»)
  initials: { type: String, default: '' },
  size: { type: Number, default: 28 }
})

const COLORS = [
  '#e17076',
  '#7bc862',
  '#e5ca77',
  '#65aadd',
  '#a695e7',
  '#ee7aae',
  '#6ec9cb',
  '#faa774'
]

const color = computed(() => {
  let hash = 0
  for (const char of String(props.author || '')) {
    hash = (hash * 31 + char.codePointAt(0)) % 4096
  }
  return COLORS[hash % COLORS.length]
})

// На старі відповіді роута ініціалів може не бути — тоді беремо першу літеру
const letters = computed(
  () => props.initials || (props.author || '?').slice(0, 1).toUpperCase()
)

const box = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`
}))

// --- Аватарка, якої насправді немає ---
// Людина може видалити фото в телеграмі, а посилання на нього лишиться в
// розмітці коментаря. На такий запит tx.me віддає 404 — але з прозорим гіфом
// 1x1 замість помилки, і браузер вважає, що картинка завантажилась успішно.
// Тому onerror тут не спрацює, і ловимо ми саме розмір: справжні аватарки
// приходять 320x320.
const imgRef = ref(null)
const broken = ref(false)

const check = (img) => {
  if (img?.complete && img.naturalWidth <= 1) broken.value = true
}

// Картинка з кешу буває готова ще до того, як ми повісимо слухача
onMounted(() => check(imgRef.value))

// Той самий кружечок можуть перевикористати під іншого автора
watch(
  () => props.avatar,
  () => {
    broken.value = false
    nextTick(() => check(imgRef.value))
  }
)
</script>

<template>
  <img
    v-if="avatar && !broken"
    ref="imgRef"
    :src="avatar"
    :alt="author"
    class="flex-shrink-0 bg-base-200 rounded-full object-cover"
    :style="box"
    loading="lazy"
    @load="check($event.target)"
    @error="broken = true"
  />
  <div
    v-else
    class="flex flex-shrink-0 justify-center items-center rounded-full font-semibold text-white uppercase leading-none"
    :style="{
      ...box,
      backgroundColor: color,
      fontSize: `${Math.round(size * 0.36)}px`
    }"
  >
    {{ letters }}
  </div>
</template>
